import {BACKEND} from "../config/backend";
import {axiosPrivate} from "../axios-config/axiosPrivate";
import {axiosPublic} from "../axios-config/axiosPublic";
import {multipartRequestConfig} from "../axios-config/requestConfig";

export const STUDIO_BASE_URL = `${BACKEND}/api/v1/studio`

export const createTicket = ({ticket}) => {
    const {files, subject, description, type, email, phone, userId} = ticket
    const formData = new FormData()
    for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i])
    }
    formData.append('type', type)
    formData.append('email', email)
    formData.append('phone', phone)
    formData.append('subject', subject)
    formData.append('description', description)
    
    // Add user ID if available (for tickets from non-authenticated users)
    if (userId) {
        formData.append('userId', String(userId))
    }

    return axiosPrivate.post(`${STUDIO_BASE_URL}/tickets`, formData, {
        ...multipartRequestConfig
    })
}

/**
 * Creates a support ticket without authentication (for public signup page)
 * @param {Object} ticket - The ticket data including userReference for identification
 */
export const createPublicTicket = ({ticket}) => {
    const {files, subject, description, type, email, phone, userReference} = ticket
    const formData = new FormData()
    
    if (files && files.length > 0) {
        for (let i = 0; i < files.length; i++) {
            formData.append('files', files[i])
        }
    }
    
    formData.append('type', type || 'SUPPORT_REQUEST')
    formData.append('email', email)
    if (phone) {
        formData.append('phone', phone)
    }
    formData.append('subject', subject)
    formData.append('description', description)
    
    // Add user ID for identification
    if (userReference?.userId) {
        formData.append('userId', String(userReference.userId))
    }

    return axiosPublic.post(`${STUDIO_BASE_URL}/tickets/public`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}
